import React from 'react';
import PropTypes from 'prop-types';

import Form from 'react-bootstrap/Form';
import Input from 'react-phone-number-input/input';

const FormInput = (props) => {
  const {
    type = 'text',
    name,
    value,
    onChange,
    placeHolder = '',
    className,
    disabled,
  } = props;

  if (type === 'phone') {
    return (
      <Form.Control
        as={Input}
        country="US"
        value={value}
        onChange={onChange}
        placeholder="(123) 456-7890"
        name={name}
        disabled={disabled}
        style={{ maxWidth: '250px' }}
      />
    );
  }
  return (
    <Form.Control
      className={className}
      type={type}
      name={name}
      value={value}
      onChange={onChange}
      placeholder={placeHolder}
      disabled={disabled}
    />
  );
};

FormInput.propTypes = {
  type: PropTypes.string,
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  placeHolder: PropTypes.string,
  className: PropTypes.string,
  disabled: PropTypes.bool,
};

FormInput.defaultProps = {
  type: 'text',
  placeHolder: '',
  className: null,
  disabled: false,
};

export default FormInput;
